import { NOTIFICATION_LEVEL } from '@/helpers/constants';

const state = {
  show: false,
  notifications: []
};

const actions = {
  success({ dispatch }, payload) {
    payload.level = NOTIFICATION_LEVEL.SUCCESS;
    dispatch('push', payload);
  },
  info({ dispatch }, payload) {
    payload.level = NOTIFICATION_LEVEL.INFO;
    dispatch('push', payload);
  },
  error({ dispatch }, payload) {
    payload.level = NOTIFICATION_LEVEL.ERROR;
    dispatch('push', payload);
  },
  push(state, payload) {
    const id = Date.now();
    state.commit('push', payload);

    // Remove the message after the delay or 15 sec if no delay is provided
    setTimeout(() => {
      state.commit('remove', id);
    }, payload.delay ? payload.delay : 5000);
  },
};

const mutations = {
  push(state, payload) {
    state.notifications.push(payload);
  },
  remove(state, id) {
    const idx = state.notifications.findIndex(n => n.id === id);
    state.notifications.splice(idx, 1);
  },
};

const getters = {
  isDisplayed: (state) => state.notifications && state.notifications.length > 0,
};

export default {
  namespaced: true,
  state: state,
  getters,
  actions,
  mutations,
};
